fx.ns("desktop.book.edition", class Welcome extends fx.components.ScreenPopup{
    
	constructor()
	{
		super();

        this.contentWidth = 800;
        this.contentHeight = 500;

        this.options = {top : "center", left : "center"};

		this.destroyOnSwitch = true;
        this._step = "step1";
	}

	create()
	{
        super.create();

        let title = new fx.components.Text({text : fx.text("Bienvenue dans votre album") + " " +  fx.get("assets").iconButton3d.render("icon"), className : "title center"});
        this.addChild(title, {width:"100%", top : 0, left : "center"});

        this.nextButton = new fx.components.IconButton({icon:fx.assets.nextIcon, className : "next", filled : false});
        this.addChild(this.nextButton, {width:80, height : 80, top : 420, left : "center"});

        this.startButton = new fx.components.Button({label:fx.text("C'est parti !"), className : "start", filled : false});
        this.startButton.visibleAtStart = false;
        this.addChild(this.startButton, {width:"200", height : 40, top : 460, left : "center"});

        this._addStep1();
        this._addStep2();
        this._addStep3();
	}

    onReady()
    {
        this.on("click", this._onNext, this.nextButton);
        this.on("click", this.onClose, this.startButton);
    }

    _addStep1()
    {
        this.step1Container = new fx.components.Box();
        this.step1Container.showEffect = "hslideout";
        this.step1Container.hideEffect = "hslidein";
        
		let text1 = new fx.components.Text({text : fx.text("Voici quelques informations rapides<br>avant de commencer"), className : "text1 center"});
		this.step1Container.addChild(text1, {width:"100%", top : 100, left : "center"});

        this.addChild(this.step1Container, {width : "100%", left : 0, top : 80, bottom:100});
    }

    _addStep2()
    {
        this.step2Container = new fx.components.Box();
        this.step2Container.showEffect = "hslideout";
        this.step2Container.hideEffect = "hslidein";
        this.step2Container.visibleAtStart = false;
        
		let text1 = new fx.components.Text({text : fx.text("L'effet 3D sera appliqué lors de l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas l'effet 3D dans l'éditeur</span>"), className : "text1 center"});
		this.step2Container.addChild(text1, {width:"100%", top : 30, left : "center"});

        this.addChild(this.step2Container, {width : "100%", left : 0, top : 80, bottom:100});
    }

    _addStep3()
    {
        this.step3Container = new fx.components.Box("container");
        this.step3Container.showEffect = "hslideout";
        this.step3Container.hideEffect = "hslidein";
        this.step3Container.visibleAtStart = false;
        
		let text1 = new fx.components.Text({text : fx.text("Choisissez bien vos photos, pour un <span class='green'>effet optimal</span>"), className : "text1 center"});
		this.step3Container.addChild(text1, {width:"100%", top : 0, left : "center"});

        let picture = new fx.components.Image( fx.assets.examplePicture );
        this.step3Container.addChild(picture, {width:400, height : 267,  top : 70, left : "center"});

        let checked1 = new fx.components.Image({data: fx.get("assets").checkedIcon, className : "checked"});
        let checked2 = new fx.components.Image({data: fx.get("assets").checkedIcon, className : "checked"});
        let checked3 = new fx.components.Image({data: fx.get("assets").checkedIcon, className : "checked"});

        let line1 = new fx.components.Image({data: fx.get("assets").line1});
        let line2 = new fx.components.Image({data: fx.get("assets").line1});
        let line3 = new fx.components.Image({data: fx.get("assets").line2});

        this.step3Container.addChild(checked1, {width:40, height : 40,  top : 75, left :50});
        this.step3Container.addChild(checked2, {width:40, height : 40,  top : 305, left :55});
        this.step3Container.addChild(checked3, {width:40, height : 40,  top : 110, right :80});

        this.step3Container.addChild(line1, {width:160, height : 67,  top : 130, right :130});
        this.step3Container.addChild(line2, {width:170, height : 40,  top : 250, left :100});
        this.step3Container.addChild(line3, {width:120, height : 40,  top : 85, left :100});

        let text2 = new fx.components.Text({text : fx.text("Arrière plan avec de la matière<br>et une profondeur raisonnable"), className : "text center"});
        let text3 = new fx.components.Text({text : fx.text("Sujet au<br>premier plan"), className : "text center"});
        let text4 = new fx.components.Text({text : fx.text("de 1 à 4<br>personnes max"), className : "text center"});

		this.step3Container.addChild(text2, {top : 125, left : -40});
        this.step3Container.addChild(text3, {top : 235, left : 10});
        this.step3Container.addChild(text4, {top : 160, right : 40});

        this.addChild(this.step3Container, {width : "100%", left : 0, top : 80, bottom:100});
    }

    _onNext()
    {
        if (this._step == "step1")
        {
            this.step1Container.hide();
            this.step2Container.show();
            this._step = "step2";
        }
        else
        if (this._step == "step2")
        {
            this.step2Container.hide();
            this.step3Container.show();
            this._step = "step3";

            this.nextButton.hide();
            this.startButton.show();
        }
    }

});

	